export function calcVerbImgSrc(infinitive) {
  return `/assets/img/verbs/${infinitive}.jpeg`;
}
